import React, {useState, useEffect} from 'react'
import '../styles/styles.css'
import { config } from '../server'
import {Link} from 'react-router-dom'
import '../styles/styles.css'
import '../styles/find.css'
//import blankProfile from '../blankProfile.png'
import { useAuth0 } from '@auth0/auth0-react';
const address = config.url.API_URL

const Find = () => {
const [showTutor, setShowTutor] = useState(false)
const [subject, setSubject] = useState("")
//const [user_dep] = useContext(IsLoggedContext)
const [tutors, setTutors] = useState([])
const [, setSent] = useState([])
const [filter, setFilter] = useState('all')
const { user, isAuthenticated, isLoading } = useAuth0();

useEffect(() => {
	fetch(address + '/api/tutors').then(res => res.json()).then(data => {
		setTutors(data.tutors)
	})
	const getRequests = async () => {
		const res = await fetch(`${address}/api/${user.nickname}/sentRequests`)
		const data = await res.json()
		setSent(data.sentRequests)
	}
	getRequests()
}, [user])
const handleSubmit = async (e) => {
	e.preventDefault()
	const requestOptions = {
		method: 'POST',
		headers: { 
		'content-type': 'application/json' },
		body: JSON.stringify({ username: user.nickname, subject: subject })
	};
	console.log(subject)
	if(subject.length >= 3) {
	fetch(address + '/findTutor', requestOptions).then(res => res.json()).then(() => {
	//console.log(data)
	setShowTutor(!showTutor)
	})
} else {
	alert('Please enter a subject!')
	setShowTutor(!showTutor)
	return;
}

}

/*const requestJoin = async (status, tutorName) => {
	const requestOptions = {
		method: 'POST',
		headers: {
		  'content-type': 'application/json' },
		body: JSON.stringify({ tutorName: tutorName, studentName: user })
	};
	if(status === 'requested') {
		await fetch(address + '/api/requestTutor', requestOptions)
		//setRequest(!requested)
	} 
}*/



/*
{sent.length > 0 && tutor.username === sent[index].requestedUser && (
			<button className="blueBtn">Pending</button>)}
			{sent.length > 0 && tutor.username !== sent[index].requestedUser && (
			<button className="blueBtn" onClick={() => sendMail(tutor.username)}>Send Email</button>)}
			{sent.length === 0 && <button className="blueBtn" onClick={() => sendMail(tutor.username)}>Send Email</button>}

			<div className="tutorButtonContainer">
				<button className="tealBtn verticalCenterBtn" onClick={() => setShowTutor(!showTutor)}>New Listing</button>
			</div>

*/

	const handleFilter = (e) => {
		e.preventDefault()
		fetch(address + `/api/tutors/${filter}`).then(res => res.json()).then(data => {
			console.log(data.tutors)
			setTutors(data.tutors)
		})
	}




if (isLoading) {
	return <div>Loading ...</div>;
  }

	return (
		isAuthenticated && (
		<>
		
		<div className="heroContainer">
			<h1>Tutoring</h1>
			<p>View the listing below to connect with a tutor.</p>
		</div>
	
		<div className="tutorListingsContainer">

		<h2 className="is-size-2">Filter Results</h2>
		<form onSubmit={handleFilter}>
		<div className="select is-medium">
			<select value={filter} onChange={e => setFilter(e.target.value)}>
    			<option value="all">All</option>
    			<option value="math">Math</option>
				<option value="science">Science</option>
    			<option value="english">English</option>
    			<option value="socialStudies">Social Studies</option>
  			</select>
		</div>
		<input type='submit' className="button is-info is-medium"/>
		</form>
			<br/>
			{tutors.map((tutor, index) => (
				<div key={JSON.stringify(tutor._id)} className="tutorCard">
					<div className="tutorCardHeader">
						<img src={tutor.picture} alt="profile" style={{borderRadius: '10%'}} />
					</div>
					<div key={index+3} className="tutorCardContent">
						<div className="tutorCardSubject">
							{tutor.fullName}
						</div> 
						<div key={index+4} className="content">
							{tutor.math && <>
							<p className="has-text-weight-bold">Teaches: Math</p>
							</>}
							{tutor.english && <>
							<p className="has-text-weight-bold">Teaches: English</p>
							</>}
							{tutor.science && <>
							<p className="has-text-weight-bold">Teaches: Science</p>
							</>}
							{tutor.socialStudies && <>
							<p className="has-text-weight-bold">Teaches: Social Studies</p>
							</>}
							{tutor.location.length > 2 && <p>From: {tutor.location}</p>}
							{user.fullName}
						<Link className="blueBtn" to={{pathname: `/chat/${tutor.name}`}}>Connect</Link>
						</div>
					</div>
				</div>
			))}
		</div>

		{showTutor && <div className="Modal">
		<form onSubmit={(e) => handleSubmit(e)}>
			<label style={{color: 'white'}}>Enter the subject</label>
		<input placeholder="Subject" className="input" 
			value={subject}
		name="subject" type="text" style={{borderRadius: 5}} onChange={e => setSubject(e.target.value)} />
		<div style={{paddingTop: '2.5%'}}>
			<button className="button is-link">Submit</button>
		</div>
		</form>
		
		</div>}

		</>
		)
	)
}

export default Find